import type {SelectedPanel} from '@wandb/forge-shell-contract/aria';

/**
 * panelKey is a panel chip's identity.
 *
 * NOTE: panel IDs aren't guaranteed stable between views of the same project,
 * so view is part of the key. Entity/project remain as a fallback namespace for
 * older prompt parts that do not carry view identity.
 */
export function panelKey(panel: SelectedPanel): string {
  return JSON.stringify([
    panel.entityName,
    panel.projectName,
    panel.viewId,
    panel.viewType,
    panel.panelId,
  ]);
}
